import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jtgl",
  "use": "icon-jtgl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jtgl\"><defs><style type=\"text/css\"></style></defs><path d=\"M373 96h218v173H373z\" p-id=\"2368\" /><path d=\"M426 960V596h112v364\" p-id=\"2369\" /><path d=\"M570 960V628h390v-64H704.8L623 300.3V64H341v236.3L309.6 396H64v232h330v332m64 0V628h48v332M405 128h154v128H405V128zM128 460h162.4l-31.2 104H128V460z\" p-id=\"2370\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol